import { /* baseClient, */ authClient, API } from '../index'

export const login = (credentials) => {
  return authClient().post(`${API}/user/signinAdmin`, credentials)
}

export const register = (body) => {
  return authClient().post(`${API}/user/signup`, body);
}

export const logout = () => {
  return authClient().get(`${API}/user/logout`)
}

export const getCredentials = () => {
  return authClient().get(`${API}/user/credentials`)
}

export const refreshTokens = () => {
  return authClient().get(`${API}/user/refresh`)
}

// Get all users
export const getUsers = () => {
  return authClient().get(`${API}/user`)
}

// Get user by id
export const getUserById = (id) => {
  return authClient().get(`${API}/user/${id}`)
}

// Delete user
export const deleteUser = (id) => {
  return authClient().delete(`${API}/user/${id}`)
}

// Validate user
export const validateUser = (id) => {
  return authClient().put(`${API}/user/validate/${id}`)
}

// Create user
export const postUser = (user) => {
  return authClient().post(`${API}/user`, user)
}

// Update user
export const updateUser = (id, user) => {
  return authClient().put(`${API}/user/${id}`, user)
}

/** Usuarios del portal (solo lectura, sin admins/moderators). Requiere sesión admin. */
export const getAdminMenuBadges = () => {
  return authClient().get(`${API}/user/admin-menu-badges`)
}

export const getPortalCustomers = (params) => {
  const search = new URLSearchParams()
  if (params?.email) search.set('email', String(params.email).trim())
  if (params?.limit) search.set('limit', String(params.limit))
  const q = search.toString()
  return authClient().get(`${API}/user/portal-customers${q ? `?${q}` : ''}`)
}

export const getPortalCustomerById = (id) => {
  return authClient().get(`${API}/user/portal-customers/${id}`)
}

/** Admin: actualizar plan y/o fecha del próximo cargo recurrente (queda en logs-planes). */
export const patchPortalCustomerSubscription = (id, body) => {
  return authClient().patch(`${API}/user/portal-customers/${id}/subscription`, body)
}

export const syncPortalCustomerStripeBilling = (id) => {
  return authClient().post(`${API}/user/portal-customers/${id}/sync-stripe-billing`)
}